import React, { useState } from 'react'
import ReactDOM from 'react-dom'

import { REGIONS } from './constants'
import { NcMap } from './nc-map'
import { UsMap } from './us-map'
import { GlobalMap } from './global-map'
import { convertRegionDataFromR } from './region-data'
import { useStyles } from './map-chart.style'

export const MapChart = ({ region, dataSets, onClick, width, height, showKey = true, mapKeyPosition, keyOffset, zoomState, onZoomIn, onZoomOut }) => {
  const classes = useStyles()
  const [dataSet, setDataSet] = useState(0)
  const RegionMap = getRegionComponent(region)

  function rotateDataSet (inc) {
    const newIndex = (dataSet + inc + dataSets.length) % dataSets.length
    setDataSet(newIndex)
  }

  return (
    <div className={classes.container}>
      {/* Don't show the data set navigator if there is only one data set */}
      { dataSets.length > 1 &&
        <div className={classes.dataSetNavigator}>
          <img className={classes.chevron} onClick={() => rotateDataSet(-1)} src="//cdnjs.cloudflare.com/ajax/libs/open-iconic/1.1.1/svg/chevron-left.svg" />
          <div className={classes.selectWrapper}>
            <select className={classes.select} value={dataSet} onChange={(event) => {
              setDataSet(event.target.value)
            }}>
              {dataSets.map(({ label }, i) => {
                return (
                  <option key={label} value={i}>{label}</option>
                )
              })}
            </select>
          </div>
          <img className={classes.chevron} onClick={() => rotateDataSet(1)} src="//cdnjs.cloudflare.com/ajax/libs/open-iconic/1.1.1/svg/chevron-right.svg" />
        </div>
      }
      <div>
        <RegionMap
          key={dataSet}
          {...dataSets[dataSet]}
          regionData={dataSets[dataSet].regionData[0].data}
          width={width}
          height={height}
          onClick={onClick}
          showKey={showKey}
          keyOffset={keyOffset}
          zoomState={zoomState}
          onZoomIn={onZoomIn}
          onZoomOut={onZoomOut}
          mapKeyPosition={mapKeyPosition}
        />
      </div>
    </div>
  )
}

export async function mapWidget (id, { region, dataSets }) {
  dataSets = dataSets.map((dataSet) => ({
    label: dataSet.label,
    valueLabel: dataSet.value_label,
    valueType: dataSet.value_type,
    mapKeyNote: dataSet.map_key_note,
    scaleOptions: dataSet.scale_options,
    colorRange: dataSet.color_range,
    regionData: dataSet.region_data.map(({ num, label, data }) => ({
      num,
      label,
      data: convertRegionDataFromR(data)
    }))
  }))

  const element = document.getElementById(id)
  ReactDOM.render(
    React.createElement(MapChart, { region, dataSets }),
    element
  )
}

function getRegionComponent (region) {
  switch (region) {
    case REGIONS.NC:
      return NcMap
    case REGIONS.GLOBAL:
      return GlobalMap
    default:
      return UsMap
  }
}
